import { mdiArrowLeft } from '@mdi/js';

import React from 'react';

import QRCode from 'qrcode.react';

import PropTypes from 'prop-types';

import {
  Wrapper,
  Document,
  Title,
  // SubTitle,
  Text,
  CodeContainer,
  QrCodeImage,
  HeaderContainer,
  Header,
  HelpBackgroundHeader,
  StyledIcon,
  IconContainer,
  QrCodeLink,
  IconClick,
} from './styles';

import link from '~/assets/icons/link.svg';
import { LogoImage } from '~/shared/components/logoImage';

const Help = ({ setClose, token }) => {
  const validationKey = token;
  const tokenRef = `${process.env.REACT_APP_FARMACEUTICO_URL}receita/${validationKey}`;
  return (
    <Wrapper>
      <HeaderContainer>
        <HelpBackgroundHeader BackgroundHeight="188px" />
        <Header>
          <IconContainer>
            <IconClick onClick={setClose}>
              <StyledIcon size={1} icon={mdiArrowLeft} />
            </IconClick>
          </IconContainer>
          <LogoImage />
        </Header>
      </HeaderContainer>
      <Title>Ajuda</Title>
      <Document>
        {/* <SubTitle>Problema?</SubTitle> */}
        <Text style={{ marginTop: 24 }}>
          A Receita Digital é assinada conforme padrão ICP-Brasil - Regulado
          pela MP 2200-2/2001, o que garante sua autenticidade, integridade e
          validade jurídica de documentos em forma eletrônica.
        </Text>
        <Text>
          A Receita Digital pode ser dispensada por qualquer farmácia.
        </Text>
        <Text>Para comprar, mostre este código ao farmacêutico:</Text>
        <CodeContainer>
          <QrCodeImage>
            <QRCode value={tokenRef} />
          </QrCodeImage>
        </CodeContainer>
        <QrCodeLink>
          <a href={`https://${tokenRef}`} rel="noreferrer">
            <img src={link} alt="validação" />
            {`${process.env.REACT_APP_FARMACEUTICO_URL}receita/${validationKey}`}
          </a>
        </QrCodeLink>
      </Document>
    </Wrapper>
  );
};

Help.propTypes = {
  setClose: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
};

export default Help;
